<template>
	<div class="confirmRegion">
		<div class="region_title">确认国家地区</div>
		<div class="region_subtitle">
			上线初期建议投放全球并排除中国，您可在下方选择不想投放的国家/地区
		</div>
		<el-autocomplete
			style="width: 450px"
			v-model="stateOne"
			:fetch-suggestions="querySearchAsyncOne"
			:trigger-on-focus="false"
			placeholder="请输入内容"
			@select="handleSelectOne"
		></el-autocomplete>
		<span class="batch_button" @click="openRemoveDialog(1)">批量排除</span>
		<removeDialog
			title="批量排除国家/地区"
			:dialogVisible="removeFlag"
			@changeDia="changeDia"
			@confirmR="confirmR"
		></removeDialog>
		<div class="region_subtitle">已排除</div>
		<el-tag
			style="margin-bottom: 15px"
			v-for="(tag, index) in excludeList"
			:key="index"
			:closable="tag.closable"
			@close="removeExcludeList(tag)"
		>
			{{ tag.value || tag.regionName }}
		</el-tag>
		<div class="region_subtitle">
			我有重点想要的国家/地区（初期不建议选择）
			<a v-if="showimpor == false" @click="changeShowimpro">展开</a>
			<a v-if="showimpor == true" @click="changeShowimpro">收起</a>
		</div>
		<div v-if="showimpor == true || importantRegionList">
			<el-autocomplete
				style="width: 450px"
				v-model="stateTwo"
				:fetch-suggestions="querySearchAsyncTwo"
				:trigger-on-focus="false"
				placeholder="请输入内容"
				@select="handleSelectTwo"
			></el-autocomplete>
			<span class="batch_button" @click="openRemoveDialog(2)">批量定位</span>
			<removeDialog
				title="批量定位国家/地区"
				:dialogVisible="locationFlag"
				@changelaDia="changelaDia"
				@confirmL="confirmL"
			></removeDialog>
			<div class="region_subtitle">重点添加</div>
			<el-tag
				style="margin-bottom: 15px"
				v-for="(tag, index) in keyList"
				:key="index"
				closable
				@close="removeKeyList(tag)"
			>
				{{ tag.value || tag.regionName }}
			</el-tag>
		</div>
	</div>
</template>
<script>
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import removeDialog from '@/components/adsOnlineAuto/com/removeDialog.vue';
export default {
	props: ['removeRegionList', 'importantRegionList'],
	components: { removeDialog },
	data() {
		return {
			stateOne: '',
			stateTwo: '',
			excludeList: {
				type: Array,
			},
			keyList: {
				type: Array,
			},
			showimpor: false,
			removeFlag: false,
			locationFlag: false,
		};
	},
	methods: {
		openRemoveDialog(val) {
			if (val == 1) {
				this.removeFlag = true;
			} else if (val == 2) {
				this.locationFlag = true;
			}
		},
		confirmR(value) {
			this.$emit('confirmRemove', value);
		},
		confirmL(value) {
			this.$emit('confirmLocation', value);
		},
		changeDia(val) {
			this.removeFlag = val;
		},
		changelaDia(val) {
			this.locationFlag = val;
		},
		async querySearchAsyncOne(queryString, cb) {
			let res = await adsNewOnlineSer.getgeotargets({
				name: queryString,
			});
			let geotargetsOne = res.data;
			let results = [];
			let geolist = JSON.parse(JSON.stringify(geotargetsOne).replace(/name/g, 'value'));
			results = queryString ? geolist : results;
			cb(results);
		},
		handleSelectOne(item) {
			this.addExcludeList(item);
			this.$emit('getlistData', this.excludeList, this.keyList);
			this.stateOne = '';
		},
		async querySearchAsyncTwo(queryString, cb) {
			let res = await adsNewOnlineSer.getgeotargets({
				name: queryString,
			});
			let geotargetsTwo = res.data;
			let results = [];
			let geolist = JSON.parse(JSON.stringify(geotargetsTwo).replace(/name/g, 'value'));
			results = queryString ? geolist : results;
			cb(results);
		},
		handleSelectTwo(item) {
			this.addKeyList(item);
			this.$emit('getlistData', this.excludeList, this.keyList);
			this.stateTwo = '';
		},
		addExcludeList(value) {
			if (
				this.excludeList.findIndex(target => target.regionId === value.id) == -1 &&
				this.keyList.findIndex(target => target.regionId === value.id) == -1
			) {
				this.excludeList.push(value);
			}
		},
		removeExcludeList(tag) {
			this.excludeList.splice(this.excludeList.indexOf(tag), 1);
			this.$emit('getlistData', this.excludeList, this.keyList);
		},
		addKeyList(value) {
			if (
				this.excludeList.findIndex(target => target.regionId === value.id) == -1 &&
				this.keyList.findIndex(target => target.regionId === value.id) == -1
			) {
				this.keyList.push(value);
			}
		},
		removeKeyList(tag) {
			this.keyList.splice(this.keyList.indexOf(tag), 1);
		},
		changeShowimpro() {
			this.showimpor = !this.showimpor;
		},
	},
	watch: {
		removeRegionList: {
			handler(val) {
				if (val) {
					// 取消俄罗斯注释
					// let defaultList = [ { "regionId": "2736", "regionName": "苏丹" }, { "regionId": "2643", "regionName": "俄罗斯" }];
					// let v = val.filter(item => item.regionName !== "苏丹" && item.regionName !== "俄罗斯");
					let defaultList = [{ regionId: '2736', regionName: '苏丹' }];
					let v = val.filter(item => item.regionName !== '苏丹');
					this.excludeList = v.concat(defaultList);
				} else {
					// 取消俄罗斯注释
					// this.excludeList = [
					// 	{ regionId: '2736', regionName: '苏丹' },
					// 	{ regionId: '2643', regionName: '俄罗斯' },
					// ];
					this.excludeList = [{ regionId: '2736', regionName: '苏丹' }];
				}
			},
		},
		importantRegionList: {
			handler(val) {
				val ? (this.keyList = val) : (this.keyList = []);
			},
		},
		excludeList: {
			handler(val) {
				val.forEach(element => {
					// 取消俄罗斯注释
					// if (element.regionName == '苏丹' || element.regionName == '俄罗斯') {
					if (element.regionName == '苏丹') {
						element.closable = false;
					} else {
						element.closable = true;
					}
				});
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.confirmRegion {
	min-height: 485px;
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	border-radius: 4px;
	padding: 20px 25px;
	margin-bottom: 10px;

	.region_title {
		font-size: 18px;
		font-weight: 500;
		margin-bottom: 40px;
	}

	.region_subtitle {
		margin: 20px 0;
	}

	.batch_button {
		margin-left: 10px;
		font-size: 14px;
		font-weight: 400;
		color: #3da1ff;
		cursor: pointer;
	}

	.el-tag + .el-tag {
		margin-left: 10px;
	}
}
</style>
